(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[195],{

/***/ 4508:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog",
      function () {
        return __webpack_require__(4040);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4040:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* reexport */ BlogHome; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(7458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(2983);
// EXTERNAL MODULE: ../../packages/ui/src/blocks/layout/site-layout.tsx + 2 modules
var site_layout = __webpack_require__(792);
// EXTERNAL MODULE: ../../packages/ui/src/components/heading/heading.tsx
var heading = __webpack_require__(8158);
// EXTERNAL MODULE: ../../packages/ui/src/components/link/link.tsx
var link_link = __webpack_require__(445);
// EXTERNAL MODULE: ../../packages/ui/src/components/image/image.tsx
var image_image = __webpack_require__(7457);
// EXTERNAL MODULE: ../../packages/ui/src/utilities/image.ts
var utilities_image = __webpack_require__(9098);
;// CONCATENATED MODULE: ../../packages/ui/src/pages/blog/home.tsx





function BlogHome(param) {
    let { directories  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(site_layout/* default */.Z, {
        title: "Blog",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "min-h-full",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(heading/* Heading */.X, {
                    className: "my-10 font-bold",
                    children: "Blog"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                    className: "flex min-h-full flex-row space-x-2 py-10",
                    children: directories.map((dir)=>{
                        if (!dir.route) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
                        }
                        const bannerProps = (0,utilities_image/* getBannerProps */.U)(dir.banner);
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(link_link/* Link */.r, {
                                href: dir.route,
                                variant: "plain",
                                children: [
                                    bannerProps && /*#__PURE__*/ (0,jsx_runtime.jsx)(image_image/* Image */.E, {
                                        ...bannerProps,
                                        alt: "Banner"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(heading/* Heading */.X, {
                                        as: "h4",
                                        children: dir.title
                                    })
                                ]
                            })
                        }, dir.route);
                    })
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/pages/blog/index.tsx
var __N_SSG = true;



/***/ }),

/***/ 7457:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ Image; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7458);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1493);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2983);



function Image(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
        ...props
    });
}


/***/ }),

/***/ 9098:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ getBannerProps; }
/* harmony export */ });
/* harmony import */ var _chirpy_dev_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6673);

function getBannerProps(banner) {
    if (_chirpy_dev_utils__WEBPACK_IMPORTED_MODULE_0__/* .isSSRMode */ .kp || !banner) {
        return null;
    }
    const url = new URL(banner, window.location.origin);
    const width = Number.parseInt(url.searchParams.get("width") || "0", 10);
    const height = Number.parseInt(url.searchParams.get("height") || "0", 10);
    return {
        src: url.pathname,
        width,
        height
    };
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [448,849,493,798,792,774,888,179], function() { return __webpack_exec__(4508); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);